// import React, { useState, useEffect } from 'react';
// import { FaReact } from 'react-icons/fa';
// import ContactUsSlider from '../../../components/Common/ContactUsSlider';
// import useApiCallHooks from '../../../hooks/useApiCallHooks';
// export default function ProductSection() {
//   const [responce, loading, error, callAPI] = useApiCallHooks();
//   const [allKits, setAllKits] = useState([]);
//   const [grades, setGrades] = useState([]);
//   const [selectedGrade, setSelectedGrade] = useState('');
//   useEffect(() => {
//     callAPI('get', 'robotics-kits');
//   }, []);
//   useEffect(() => {
//     if (responce?.data && Array.isArray(responce.data)) {
//       const kits = responce.data.map(kit => ({
//         name: kit.name,
//         price: kit.price,
//         price_range: `₹${kit.price}`,
//         level: kit.level || '',
//         grade: kit.grades || '',
//         image: kit.image,
//         whats_inside: kit.what_you_learn || [],
//         projects: (kit.projects || []).map(p => p.name),
//         skills: kit.what_you_learn || []
//       }));
//       // Get unique grades
//       const uniqueGrades = [...new Set(kits.map(k => k.grade))].sort((a, b) => Number(a) - Number(b));
//       setAllKits(kits);
//       setGrades(uniqueGrades);
//       setSelectedGrade(uniqueGrades[0] || '');
//     }
//   }, [responce]);
//   const handleGradeChange = (e) => {
//     setSelectedGrade(e.target.value);
//   };
//   // Final filtering by selected grade (as per admin’s definition)
//   const filteredKits = allKits.filter(kit => kit.grade === selectedGrade);
//   return (
//     <div className="container py-5">
//       {/* Header */}
//       <div className="p-4 p-md-5 text-white rounded" style={{
//         background: 'linear-gradient(to right, #004aad, #4a90e2, rgb(34, 36, 124))',
//         transition: 'all 0.3s ease-in-out'
//       }}>
//         <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
//           <div className="d-flex align-items-center">
//             <FaReact className="react-icon me-3" style={{ fontSize: '3rem', color: '#004aad' }} />
//             <div>
//               <h2 className="fw-bold text-white">Explore Grade {selectedGrade} Kits</h2>
//               <p className="mt-2 text-white">Hands-on learning tailored for Grade {selectedGrade}</p>
//             </div>
//           </div>
//           <div className="mt-3 mt-md-0">
//             <label htmlFor="gradeSelect" className="form-label text-white fw-semibold fs-4">
//               Select Grade
//             </label>
//             <select
//               id="gradeSelect"
//               className="form-control custom-select-lg"
//               onChange={handleGradeChange}
//               value={selectedGrade}
//             >
//               {grades.map((grade, index) => (
//                 <option key={index} value={grade}>
//                   Grade {grade}
//                 </option>
//               ))}
//             </select>
//             <div className="form-text text-light mt-2 fst-italic">
//               Select a grade to view matching kits (admin-defined).
//             </div>
//           </div>
//         </div>
//       </div>
//       {/* Kits Section */}
//       <div className="row mt-4 g-4 justify-content-center">
//         {filteredKits.length > 0 ? (
//           filteredKits.map((kit, index) => (
//             <div className="col-md-6" key={index}>
//               <div className="card h-100 shadow-sm border-0 rounded-4 d-flex flex-column justify-content-between card-hover bg-white">
//                 {kit.image && (
//   <img
//   src={kit.image}
//   alt={kit.name}
//   className="card-img-top rounded-top-4"
//   style={{
//     height: '100%',
//     width: '100%',
//     objectFit: 'cover', // Makes the image fill fully
//     objectPosition: 'center', // Keeps focus centered
//     borderTopLeftRadius: '1rem',
//     borderTopRightRadius: '1rem'
//   }}
// />


//                 )}
//                 <div className="card-body">
//                   <div className="d-flex justify-content-between align-items-center mb-3">
//                     <h1 className="mb-0 fw-bold">{kit.name}</h1> 
//                        {kit.level && (
//                     <span className={`badge mt-1 ${kit.level === 'Premium' || kit.level === 'Expert' ? 'bg-accent text-dark' : 'bg-secondary'}`}>
//                       {kit.level}
//                     </span>
//                   )}
//                   </div>
//                   <h6 className="mt-2 text-primary fw-bold">{kit.price_range}</h6>
                  
               
//                   <div className="d-flex gap-3 mt-4 flex-wrap">
                   


//                     <h6>Description {kit.whats_inside.join}</h6>
//                     <h6>Description {kit.projects}</h6>
//                     <h6>Description {kit.what_you_learn}</h6>

//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))
//         ) : (
//           <div className="text-center text-muted fs-5 mt-5">No kits available for Grade {selectedGrade}</div>
//         )}
//       </div>
//       {/* Contact Section */}
//       {/* <div className="mt-5">
//         <h3 className="text-primary fw-bold text-center mb-4">Get in Touch with Us</h3>
//         <ContactUsSlider />
//       </div> */}
//       {/* Styles */}
//     <style>{`
//   .custom-select-lg {
//     padding: 1rem;
//     font-size: 1.1rem;
//     border-radius: 1rem;
//     border: 2px solid #fff;
//     background-color: #e6f0fa;
//     transition: all 0.3s ease-in-out;
//   }
//   .custom-select-lg:hover {
//     border-color: #4a90e2;
//     background-color: #d1e3f6;
//     transform: translateY(-2px);
//   }
//   .custom-select-lg:focus {
//     outline: none;
//     border-color: #004aad;
//     box-shadow: 0 0 0 0.25rem rgba(0, 74, 173, 0.25);
//   }
//   .text-primary { color: #004aad !important; }
//   .text-secondary { color: #00c4cc !important; }
//   .bg-primary { background-color: #004aad !important; }
//   .bg-secondary { background-color: #00c4cc !important; }
//   .bg-accent { background-color: #4a90e2 !important; }

// .card-hover {
//   transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
//   box-shadow: box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;;
// }

// .card-hover:hover {
//   transform: translateY(-6px);
//   box-shadow: rgba(0, 0, 0, 0.35) 0px 8px 24px;
// }

// `}</style>

//     </div>
//   );
// }
// // InfoCard component
// function InfoCard({ icon, title, content, border }) {
//   return (
//     <div className="d-flex align-items-start border rounded shadow-sm p-3 position-relative flex-grow-1 info-card" style={{ borderColor: border, minWidth: 200 }}>
//       <div style={{
//         width: '6px',
//         backgroundColor: border,
//         borderRadius: '4px',
//         position: 'absolute',
//         top: '12px',
//         bottom: '12px',
//         left: 0,
//         transition: 'background-color 0.3s ease'
//       }}></div>
//       <div className="d-flex justify-content-center align-items-center rounded-circle text-primary bg-white shadow-sm"
//         style={{ width: 40, height: 40, fontSize: 20, zIndex: 1 }}>
//         {icon}
//       </div>
//       <div className="ms-2" style={{ zIndex: 1 }}>
//         <h6 className="fw-semibold mb-1">{title}</h6>
//         <p className="text-muted small mb-0">{content}</p>
//       </div>
//     </div>
//   );
// }



import React, { useState, useEffect } from 'react';
import { FaReact } from 'react-icons/fa';
import useApiCallHooks from '../../../hooks/useApiCallHooks';
import OverlayLoader from '../../../components/Common/OverlayLoader';

export default function RoboticKit() {
  const [responce, loading, error, callAPI] = useApiCallHooks();
  const [allKits, setAllKits] = useState([]);
  const [grades, setGrades] = useState([]);
  const [selectedGrade, setSelectedGrade] = useState('');

  useEffect(() => {
    callAPI('get', 'robotics-kits');
  }, []);

  useEffect(() => {
    if (responce?.data && Array.isArray(responce.data)) {
      const kits = responce.data.map(kit => ({
        name: kit.name,
        price: kit.price,
        price_range: `₹${kit.price}`,
        description: kit.description || '',
        level: kit.level || '',
        grade: kit.grades || '',
        image: kit.image,
        whats_inside: kit.what_you_learn || [],
        projects: (kit.projects || []).map(p => p.name),
        skills: kit.what_you_learn || []
      }));
      const uniqueGrades = [...new Set(kits.map(k => k.grade))].sort((a, b) => Number(a) - Number(b));
      setAllKits(kits);
      setGrades(uniqueGrades);
      setSelectedGrade(uniqueGrades[0] || '');
    }
  }, [responce]);

  const handleGradeChange = (e) => {
    setSelectedGrade(e.target.value);
  };

  const filteredKits = allKits.filter(kit => kit.grade === selectedGrade);

  return (
    <div
  className="container-fluid py-5"
  style={{ backgroundColor: "#f0f0f0" }} // light gray background
>
      <OverlayLoader show={loading} />
      
    
      {/* Header */}
      <div className="p-4 p-md-5 text-white rounded" style={{
        background: 'linear-gradient(to right, #004aad, #4a90e2, rgb(34, 36, 124))',
        transition: 'all 0.3s ease-in-out'
      }}>
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
          <div className="d-flex align-items-center">
            <FaReact className="react-icon me-3" style={{ fontSize: '3rem', color: '#004aad' }} />
            <div>
              <h2 className="fw-bold text-white">Explore Grade {selectedGrade} Kits</h2>
              <p className="mt-2 text-white">Hands-on learning tailored for Grade {selectedGrade}</p>
            </div>
          </div>
          <div className="mt-3 mt-md-0">
            <label htmlFor="gradeSelect" className="form-label text-white fw-semibold fs-5">
              Select Grade
            </label>
            <select
              id="gradeSelect"
              className="form-control custom-select-lg"
              onChange={handleGradeChange}
              value={selectedGrade}
            >
              {grades.map((grade, index) => (
                <option key={index} value={grade}>
                  Grade {grade}
                </option>
              ))}
            </select>
            <div className="form-text text-light mt-2 fst-italic">
              Select a grade to view matching kits (admin-defined).
            </div>
          </div>
        </div>
      </div>

      {/* Kits Section */}
      <div className="row mt-4 g-4 justify-content-center">
        {filteredKits.length > 0 ? (
          filteredKits.map((kit, index) => (
            <div className="col-12 col-sm-6 col-lg-4" key={index}>
              <div className="card h-100 shadow-sm border-0 rounded-4 d-flex flex-column justify-content-between card-hover bg-white">
                {kit.image && (
                  <img
                    src={kit.image}
                    alt={kit.name}
                    className="card-img-top"
                    style={{
                      width: '100%',
                      height: '220px',
                      objectFit: 'cover',
                      objectPosition: 'center',
                      borderTopLeftRadius: '1rem',
                      borderTopRightRadius: '1rem'
                    }}
                  />
                )}
                <div className="card-body d-flex flex-column">
                  <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
                    <h5 className="fw-bold text-dark mb-1">{kit.name}</h5>
                    {kit.level && (
                      <span className={`badge ${kit.level === 'Advanced' ? 'bg-accent' : 'bg-secondary'} text-white`}>
                        {kit.level}
                      </span>
                    )}
                  </div>

                  <h6 className="text-primary fw-semibold mb-3">{kit.price_range}</h6>

                  <div className="kit-section">
                    <h6 className="fw-bold mb-1">Description:</h6>
                    <p className="text-muted small">{kit.description}</p>

                    <h6 className="fw-bold mt-3 mb-2">What You'll Learn:</h6>
                    <ul className="ps-3 list-check">
                      {kit.whats_inside.map((point, idx) => (
                        <li key={idx}>
                          <i className="fas fa-check-circle text-success me-2"></i>{point}
                        </li>
                      ))}
                    </ul>

                    <h6 className="fw-bold mt-3 mb-2">Projects:</h6>
                    <div className="d-flex flex-wrap gap-2">
                      {kit.projects.map((proj, idx) => (
                        <span key={idx} className="badge bg-light border text-dark px-3 py-2 rounded-pill">{proj}</span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center text-muted fs-5 mt-5">No kits available for Grade {selectedGrade}</div>
        )}
      </div>

      {/* Styles */}
      <style>{`
        .custom-select-lg {
          padding: 1rem;
          font-size: 1.1rem;
          border-radius: 1rem;
          border: 2px solid #fff;
          background-color: #e6f0fa;
          transition: all 0.3s ease-in-out;
        }
        .custom-select-lg:hover {
          border-color: #4a90e2;
          background-color: #d1e3f6;
          transform: translateY(-2px);
        }
        .custom-select-lg:focus {
          outline: none;
          border-color: #004aad;
          box-shadow: 0 0 0 0.25rem rgba(0, 74, 173, 0.25);
        }
        .text-primary { color: #004aad !important; }
        .bg-primary { background-color: #004aad !important; }
        .bg-secondary { background-color: #00c4cc !important; }
        .bg-accent { background-color: #4a90e2 !important; }

        .card-hover {
          transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
          box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
                      rgba(0, 0, 0, 0.12) 0px -12px 30px,
                      rgba(0, 0, 0, 0.12) 0px 4px 6px,
                      rgba(0, 0, 0, 0.17) 0px 12px 13px,
                      rgba(0, 0, 0, 0.09) 0px -3px 5px;
        }

        .card-hover:hover {
          transform: translateY(-6px);
          box-shadow: rgba(0, 0, 0, 0.35) 0px 8px 24px;
        }

        .kit-section p {
          font-size: 0.95rem;
          line-height: 1.5;
        }

        .list-check {
          list-style-type: none;
          padding-left: 0;
          margin-bottom: 0;
        }

        .list-check li {
          font-size: 0.9rem;
          color: #555;
          display: flex;
          align-items: center;
          margin-bottom: 0.5rem;
        }

        .list-check i {
          margin-right: 0.5rem;
          color: #28a745;
        }
      `}</style>
    </div>
  );
}
